module.exports = __webpack_public_path__ + "media/react/pages/answer_reviews/score_report/assets/desk_with_lamp-2f250c83bf327a7a39288c0d065ab521.svg";